import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as RSSWAActions from './rsswa.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class RSSWAStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new RSSWAActions.RSSWARefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.RSSWA, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new RSSWAActions.RSSWACreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new RSSWAActions.RSSWAUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new RSSWAActions.RSSWADelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new RSSWAActions.RSSWARefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new RSSWAActions.RSSWARefreshByID(data.id));
          break;
      }
    });
  }
}
